import { createConfigSection } from '../helpers'

export default {
    ...createConfigSection('api', {
        base: 'https://beheer-acc-api.agressieregistratieoverheid.nl',
        requestTimeout: 2000
    }),

    ...createConfigSection('oidc', {
        authority: 'https://backend-oxgbe43n2cdum.azurewebsites.net/',
        post_logout_redirect_uri: 'https://beheer-acc.agressieregistratieoverheid.nl'
    })
}
